import { SvgIcon } from '@mui/material';

export function MinusIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path d="M6.25 12.7499V11.25H19.25V12.7499H6.25Z" fill="#141414" />
		</SvgIcon>
	);
}
